'use strict';

var jsxRuntime = require('react/jsx-runtime');

const SmallPackage = ()=>{
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("path", {
                d: "M4 14H28V28C28 28.5523 27.5523 29 27 29H5C4.44772 29 4 28.5523 4 28V14Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("rect", {
                x: "13.5",
                y: "14",
                width: "5",
                height: "15",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("rect", {
                x: "3",
                y: "7",
                width: "26",
                height: "7",
                rx: "1",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("rect", {
                x: "3",
                y: "7",
                width: "13",
                height: "7",
                rx: "1",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("rect", {
                x: "13.5",
                y: "7",
                width: "5",
                height: "7",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M8 5C8 3.35191 9.88153 2.41115 11.2 3.4L16 7H8V5Z",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M24 5C24 3.35191 22.1185 2.41115 20.8 3.4L16 7H24V5Z",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4"
            })
        ]
    });
};
const MediumPackage = ()=>{
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("path", {
                d: "M6 18H34V35C34 35.5523 33.5523 36 33 36H7C6.44771 36 6 35.5523 6 35V18Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("rect", {
                x: "17",
                y: "18",
                width: "6",
                height: "18",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("rect", {
                x: "5",
                y: "10",
                width: "30",
                height: "8",
                rx: "1",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("rect", {
                x: "17",
                y: "10",
                width: "6",
                height: "8",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M11 7.08928C11 5.42498 12.9142 4.4888 14.2279 5.51057L20 10H11V7.08928Z",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M29 7.08928C29 5.42498 27.0858 4.4888 25.7721 5.51057L20 10H29V7.08928Z",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4"
            })
        ]
    });
};
const Package = ({ size })=>{
    if (size === 'small') return jsxRuntime.jsx(SmallPackage, {});
    return jsxRuntime.jsx(MediumPackage, {});
};

module.exports = Package;
